// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle21 from "../../randing/RandingStyle21";

function Randing250({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle21
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/250/01.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/233/02.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      qTitleColor="#0033ff"
      qOptionColor="blue"
      formFieldColor="white"
      companyName="본원"
      privacyCompanyName="의정부아이엠치과의원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
    />
  );
}

export default Randing250;
